<template>
<div>
    <Header />
    <div class="desktop">
        <BlackHeaderCenter :headerText="headerText" :subText="subText" :fadedText="fadedText" />
    </div>
    <div class="mobile">
        <BlackHeaderMobile :headerText="headerText" :subText="subText" :fadedText="fadedText" :isTextinput="false" />
    </div>
    <BodyLinks />
    <b-container class=" mt-4">
        <Activation />
        <b-row class="">
            <b-col cols="3" class="desktop">
                <RecipeSidebar class="mt-5" create='active' />
            </b-col>
            <b-col cols="12" md="9">
                <p class="mb-4 mt-4">Create Recipe</p>
                <div class="shadow-container">
                    <p>Recipe Details</p>
                    <form @submit.prevent="createRecipie">
                        <b-row class="mt-4">
                            <div class="col-md-12">
                                <div class="file-container mb-4">
                                    <p>Upload recipe image</p>
                                    <div @click="openFile" class="btn btn-warning">Choose File
                                        <b-icon scale="0.8" icon="cloud-arrow-up"></b-icon>
                                    </div>
                                    <b-form-file @change="showFileName" style="visibility:hidden" id="recipeImg" class="mt-3" plain></b-form-file><span>{{filename}}</span>
                                </div>
                            </div>
                            <b-form-group class="col-md-6 mb-4" label-for="input-1">
                                <b-input-group class="custom-input-group">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="tag"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input list="my-list-id" @input="getRecipeName" type="text" v-model="name" placeholder="Recipe Name"></b-form-input>
                                </b-input-group>
                                <div class="autocomplete-list" v-if="recipeNames.length > 0">
                                    <ul>
                                        <li @click="selectRecipe(name)" v-for="(name, index) in recipeNames" :key="index">{{ name.title }}</li>

                                    </ul>
                                </div>
                            </b-form-group>
                            <b-form-group class="col-md-6 mb-4" label-for="origin">
                                <b-input-group class="custom-input-group">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="globe"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input type="text" required v-model="origin" placeholder="Country or tradition of recipe?"></b-form-input>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group class="col-md-6 mb-4" label-for="role">
                                <b-form-select v-model="role" required :options="roles"></b-form-select>
                            </b-form-group>

                            <b-form-group class="col-md-6 mb-4" label-for="prep_time">
                                <b-input-group class="custom-input-group">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="clock"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input type="text" required v-model="prep_time" placeholder="Prep time e.g 30mins"></b-form-input>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group class="col-md-6 mb-4" label-for="cook_time">
                                <b-input-group class="custom-input-group">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="clock"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input type="text" required v-model="cook_time" placeholder="Cook time e.g 30mins"></b-form-input>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group class="col-md-6 mb-4" label-for="role">
                                <b-form-select v-model="fee_type" required :options="feeTypes"></b-form-select>
                            </b-form-group>
                            <b-form-group class="col-md-6 mb-4" label-for="role" v-if="fee_type == 'paid'">
                                <b-form-select v-model="currency" :options="currencies"></b-form-select>
                            </b-form-group>
                            <b-form-group class="col-md-6 mb-4" label-for="role" v-if="fee_type == 'paid'">
                                <b-form-input v-model="amount" min="0" step=".01" required type="number" placeholder="Price"></b-form-input>
                            </b-form-group>

                            <b-form-group class="col-md-12 mb-3" label-for="course_description">
                                <vue-editor :editor-toolbar="customToolbar" placeholder="Tell your audience a good story about your recipe, how did you come up with it?" v-model="storyline" />
                            </b-form-group>
                            <div class="col-md-12">
                                <b-form-group class="mb-3" label-for="ingredients">
                                    <textarea required rows="5" v-model="ingredients" placeholder="Enter recipe ingredients seperated by a comma (,)" class="shadow custom-control form-control"></textarea>
                                </b-form-group>
                            </div>
                            
                        </b-row>
                        <b-row>
                            <div class="col-md-12">
                                <b-form-group class="mt-2 mb-3" label-for="ingredients">
                                    <p>Recipe Instructions</p>
                                </b-form-group>
                            </div>
                        </b-row>
                        <b-row v-for="(ins, index) in instructions" :key="'ins'+index">
                            <b-col cols="12" md="11">
                                <b-form-group class="mb-3" label-for="">
                                    <b-form-input v-model="ins.step" required type="text" placeholder="Please enter cooking step"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="1">
                                <span class="mobile mb-3 font12" style="cursor: pointer" @click="removeInstruction(index)" v-if="index>=1"> Delete Instruction </span>
                                <b-icon class="desktop" style="cursor: pointer" @click="removeInstruction(index)" v-if="index>=1" shift-v="-15" icon="trash"></b-icon>
                            </b-col>
                        </b-row>

                        <b-row class="mb-3">
                            <b-col>
                                <div @click="addInstruction" class="btn btn-secondary">+ Add </div>
                            </b-col>
                        </b-row>

                        <b-form-checkbox v-model="hire_status" switch inline class="my-2 mb-3">
                            Do you want to be hired as a chef for this recipe?
                        </b-form-checkbox>

                        <div class="file-container mb-4">
                            <p class="font14">Please read the terms and conditons before creating this
                                recipe</p>
                            <b-form-checkbox v-model="terms" id="termsCheckbox-m">
                                I accept the <span style="cursor: pointer;" @click="openTerms" class="culture-primary"> terms and conditions</span>
                            </b-form-checkbox>
                        </div>

                        <b-form-group class=" col-md-12 mb-3" label-for="input-1">
                            <button type="submit" class="float-right btn btn-warning">{{saveText}}
                                <font-awesome-icon :icon="['fas', 'arrow-right']" />
                            </button>
                        </b-form-group>

                    </form>
                </div>

            </b-col>
        </b-row>

    </b-container>
    <Footer />
</div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import BodyLinks from "@/components/BodyLinks.vue";
import Footer from "@/components/Footer.vue";
import BlackHeaderCenter from "@/components/BlackHeaderCenter.vue";
import BlackHeaderMobile from "@/components/BlackHeaderMobile.vue";
import Activation from "@/components/Activation.vue";
import RecipeSidebar from "@/components/RecipeSidebar.vue";
import axios from "axios";
import {
    getBaseUrl
} from "../../../utils/common";
const base_url = getBaseUrl();
export default {
    name: 'create-recipe',
    components: {
        Header,
        BodyLinks,
        BlackHeaderCenter,
        BlackHeaderMobile,
        Activation,
        RecipeSidebar,
        Footer
    },
    data: function () {
        return {
            headerText: "Create recipes",
            subText: "create an exqisite recipe you are familiar with",
            fadedText: "recipes",
            imgUrl: require('../../assets/images/food.png'),
            customToolbar: [
                ["bold", "italic", "underline"],
                [{
                    list: "ordered"
                }, {
                    list: "bullet"
                }]
            ],
            name: '',
            prep_time: '',
            cook_time: '',
            ingredients: '',
            storyline: '',
            origin: '',
            link: '',
            amount: '',
            filename: '',
            recipeNames: [],
            saveText: 'Add Recipe',
            terms: false,
            hire_status: false,
            role: null,
            chef_link: '',
            currencies: [{
                    value: null,
                    text: 'Select currency'
                },
                {
                    value: "USD",
                    text: 'USD'
                },
            ],
            currency: null,
            fee_type: null,
            instructions: [{
                step: ''
            }],
            roles: [{
                    value: null,
                    text: 'Select role: chef or cook'
                },
                {
                    value: "chef",
                    text: 'Chef'
                },
                {
                    value: "cook",
                    text: 'Cook'
                },
            ],
            feeTypes: [{
                    value: null,
                    text: 'Is this recipe for sale or for free?'
                },
                {
                    value: "paid",
                    text: 'For sale'
                },
                {
                    value: "free",
                    text: 'Free'
                },
            ]
        }
    },
    methods: {

        addInstruction() {
            if (this.instructions === null) {
                this.instructions = [{}];
                return;
            }
            this.instructions.push({
                step: "",

            })
        },
        removeInstruction(index) {
            this.instructions.splice(index, 1);
        },
        openFile() {
            document.getElementById('recipeImg').click()
        },
        showFileName() {
            const file = document.getElementById("recipeImg").files[0];
            this.filename = file.name
        },
        openTerms() {
            let routeData = this.$router.resolve({
                name: 'terms'
            });
            window.open(routeData.href, "_blank")
        },
        async createRecipie() {
            const ingredients = this.ingredients.split(',')
            const hirestatus = this.hire_status == false ? 0 : 1;
            let data = new FormData();
            const image = document.getElementById('recipeImg').files[0]
            if (image) {
                data.append("images", document.getElementById("recipeImg").files[0]);
            }
            data.append('name', this.name)
            data.append('role', this.role)
            data.append('origin', this.origin)
            data.append('storyline', this.storyline)
            data.append('fee_type', this.fee_type)
            if (this.currency != null) {
                data.append('currency', this.currency)
                data.append('amount', this.amount)
            }
            data.append('prep_time', this.prep_time)
            data.append('cook_time', this.cook_time)
            data.append('hire_status', hirestatus)
            ingredients.forEach((item) => data.append("ingredients[]", item))

            for (let i = 0; i < this.instructions.length; i++) {
                for (let key of Object.keys(this.instructions[i])) {
                    data.append(`instructions[${i}][${key}]`, this.instructions[i][key]);
                }
            }

            this.saveText = 'Creating...';
            if (this.terms) {
                try {
                    const resp = await axios({
                        url: `${base_url}/api/v2/foodlistings`,
                        data: data,
                        method: "POST",
                    })
                    this.saveText = 'Add Recipe';
                    this.$root.$refs.A.makeToast('success', resp.data.message)
                    this.resetForm();
                } catch (error) {
                    this.saveText = 'Add Recipe';
                    this.$root.$refs.A.makeToast('danger', error.response.data.message)
                }
            } else {
                this.saveText = 'Add Recipe';
                this.$root.$refs.A.makeToast('danger', 'Accept the terms to continue')
            }

        },
        async getRecipeName() {
            const query = this.name;
            const number = 10;
            const apikey = process.env.VUE_APP_SPOONACULAR_KEY
            delete axios.defaults.headers.common["Device-Referrer-Id"];
            if (query.length > 3) {
                try {
                    const resp = await axios({
                        url: `https://api.spoonacular.com/recipes/autocomplete?apiKey=${apikey}`,
                        params: {
                            query: query,
                            number: number
                        },
                        method: "GET",
                    })
                    this.recipeNames = resp.data;
                } catch (error) {
                    console.warn(error)
                    //this.$root.$refs.A.makeToast('danger', error.response.data.message)
                }
            }

        },
        selectRecipe(item) {
            this.name = item.title
            this.recipeNames.length = 0;
        },
        resetForm() {
            this.name = ''
            this.role = ''
            this.origin = ''
            this.storyline = ''
            this.fee_type = ''
            this.prep_time = ''
            this.cook_time = ''
            this.ingredients = ''
            this.instructions = ''
            this.filename = '',
                this.hire_status = false,
                this.terms = false
        }
    }

}
</script>

<style scoped>
.custom-select {
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
    border-radius: 8px;
    /* padding: 20px 16px; */
    border: none;
    height: 59px;
    width: 100%;
}

.custom-input-group {
    border-radius: 8px !important;
    height: 58px;
    margin: 0 !important
}

.form-control {
    border-radius: 0 8px 8px 0 !important;

}

.custom-input-group .input-group-text {
    border-radius: 8px 0 0 8px !important;
    padding: 1.2rem 2px 1.2rem 1rem !important
}

.form-control {
    border-radius: 0 8px 8px 0 !important;
    height: calc(2em + 0.75rem + 16px) !important;

}

textarea.custom-control {
    height: auto !important;
}
</style>
